import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import SessionManager from "../Utils/SessionManager";
import MyLoader from "../Spinner/MyLoader";
import myToast from "../Utils/MyToast";

const MdlSectionShift = ({
  class_id,
  current_section_id,
  session_id,
  sectionList = [],
  actionClose,
  actionSelectSection,
}) => {
  const [loading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState("");

  useEffect(() => {
    // Prefer using provided sectionList to avoid extra API calls
    if (Array.isArray(sectionList) && sectionList.length > 0) {
      const list = sectionList.filter(
        (s) => String(s.class_id) === String(class_id) && String(s.section_id) !== String(current_section_id)
      );
      setSections(list);
      if (list.length > 0) setSelectedSectionId(list[0].section_id);
      return;
    }
    // Fallback: keep modal empty; parent should supply list
    setSections([]);
  }, [class_id, current_section_id, session_id, sectionList]);

  const handleConfirm = () => {
    if (!selectedSectionId) {
      myToast.notify_warning("Select a section");
      return;
    }
    actionSelectSection(selectedSectionId);
  };

  return (
    <div className="modal" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Shift to Section</h5>
            <button type="button" className="btn-close" onClick={actionClose} />
          </div>
          <div className="modal-body">
            {loading ? (
              <MyLoader />
            ) : sections.length === 0 ? (
              <div className="alert alert-info mb-0">No other sections available.</div>
            ) : (
              <div className="row g-2">
                {sections.map((s) => (
                  <div key={s.section_id} className="col-4">
                    <button
                      className={`btn btn-outline-primary w-100 ${String(selectedSectionId) === String(s.section_id) ? "active" : ""}`}
                      onClick={() => setSelectedSectionId(s.section_id)}
                    >
                      {s.section_name}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={actionClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleConfirm} disabled={!selectedSectionId || sections.length === 0}>Shift</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MdlSectionShift;


